import { useState } from 'react';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import { useTranslation } from 'react-i18next';
import { mdiDotsVertical } from '@mdi/js';

import { ICertificateTypeListItemFragment } from 'graphql/types';
import { List } from 'common/components/List';
import { Button } from 'common/components/Button';
import { IconButton } from 'common/components/IconButton';
import { BoxLoader } from 'common/components/Loader';
import { DropdownMenu } from 'common/components/DropdownMenu';
import { CertificateSelectorListItem } from 'common/components/CertificateSelectorListItem';
import { CertificateTypePreviewModal } from 'certificate/components/CertificateTypePreviewModal';

interface IProps {
    certificate?: ICertificateTypeListItemFragment;
    loading?: boolean;
    onReplaceCertificate?(): void;
}

export const CertificateFormItem = ({
    certificate,
    loading,
    onReplaceCertificate,
}: IProps) => {
    const [translate] = useTranslation();
    const [isPreviewOpen, setPreviewOpen] = useState(false);

    if (loading) return <BoxLoader height="120px" />;

    if (!certificate) {
        return (
            <Button
                sx={{ width: '100%', height: '120px' }}
                variant="contained"
                onClick={onReplaceCertificate}
            >
                {translate('selectCertificate')}
            </Button>
        );
    }

    return (
        <>
            <List sx={{ backgroundColor: 'grey.50' }}>
                <CertificateSelectorListItem
                    disabled
                    button={false}
                    certificate={certificate}
                    footer={
                        <Grid container>
                            <Grid size="grow">
                                <Stack direction="row" spacing={2}>
                                    <Button
                                        variant="contained"
                                        onClick={() => setPreviewOpen(true)}
                                    >
                                        {translate('view')}
                                    </Button>
                                </Stack>
                            </Grid>

                            {!!onReplaceCertificate && (
                                <Grid
                                    component={Box}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}
                                >
                                    <DropdownMenu
                                        anchor={
                                            <IconButton
                                                aria-label={translate(
                                                    'actions'
                                                )}
                                                color="inherit"
                                                iconPath={mdiDotsVertical}
                                                iconSize="2.8rem"
                                            />
                                        }
                                        placement="bottom-end"
                                    >
                                        <MenuItem
                                            onClick={onReplaceCertificate}
                                        >
                                            {translate('replaceCertificate')}
                                        </MenuItem>
                                    </DropdownMenu>
                                </Grid>
                            )}
                        </Grid>
                    }
                    px={2}
                    py={0}
                    sx={{
                        flexWrap: 'wrap',
                    }}
                />
            </List>

            <CertificateTypePreviewModal
                certificateId={certificate.id}
                open={isPreviewOpen}
                onClose={() => setPreviewOpen(false)}
            />
        </>
    );
};
